// extracted by mini-css-extract-plugin
export var checkbox = "style-module--checkbox--ab9a5";
export var invoiceAddress = "style-module--invoiceAddress--bd1da";